export const TAB_IDS = {
    TEMPLATES: 1,
    DOCUMENT: 2,
    CHAT: 3,
    PROJECT: 4,
    DESIGNER: 5,
    BRAND_VOICE: 6,
    INFOBASE: 7,
};
